module.exports = __webpack_public_path__ + "img/og-screen-2.4bfdd3db.png";